import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
//import 'firebase/firestore'
import router from '@/router'
import { firebaseMutations, firebaseAction } from 'vuexfire'
//import { stat } from 'fs';
Vue.use(Vuex)

function getFirebaseProjectId() {
    return firebase.app().options.authDomain.split('.')[0];
}

export const store = new Vuex.Store({
    state: {
        appTitle: 'Portal',
        user: null,
        error: null,
        loading: false,
        message: null,
        broadcasts: [],
        aggregations: [],
        //senders: [],
        entities: [],
        //entity_doc: null,
        //document: null,
        documents: {},
        docsLoaded: {},
        docLoading: false
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload
        },
        setError(state, payload) {
            state.error = payload
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setDocLoading(state, payload) {
            state.docLoading = payload
        },
        setMessage(state, payload) {
            state.message = payload
        },
        setDocumentKey(state, payload) {
            if (Object.keys(state.documents).indexOf(payload.key) === -1) {
                state.documents = { ...state.documents, [payload.key]: payload.value }
                // Object.assign(state.documents, state.documents, { [payload.key]: payload.value }) // does not work!, documents becomes not reactive!!
            }
            if (Object.keys(state.docsLoaded).indexOf(payload.key) === -1) {
                state.docsLoaded = { ...state.docsLoaded, [payload.key]: false }
                // Object.assign(state.documents, state.documents, { [payload.key]: payload.value }) // does not work!, documents becomes not reactive!!
            }
        },
        setDocLoaded(state, payload) {
            state.docsLoaded[payload.key] = payload.value
        },
        ...firebaseMutations
    },
    actions: {
        // userSignUp({ commit }, payload) {
        //     commit('setLoading', true)
        //     firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        //         .then(firebaseUser => {
        //             commit('setUser', { email: firebaseUser.user.email })
        //             commit('setLoading', false)
        //             router.push('/home')
        //             commit('setError', null)
        //         })
        //         .catch(error => {
        //             commit('setError', error.message)
        //             commit('setLoading', false)
        //         })
        // },
        userLostPassword({ commit }, payload) {
            commit('setLoading', true)
            commit('setError', null)
            var req = new XMLHttpRequest();
            req.onload = function () {
                if (req.status === 404) {
                    commit('setError', 'Usuario no encontrado')
                    commit('setLoading', false)
                    return;
                }
                if (req.status !== 200) {
                    commit('setError', 'Invalid response from Firebase Cloud Function ' + req.status)
                    commit('setLoading', false)
                    return;
                }
                var data = JSON.parse(req.responseText);
                if (data.message) {
                    commit('setLoading', false)
                    commit('setError', null)
                    commit('setMessage', data.message)
                } else {
                    commit('setLoading', false)
                    commit('setError', 'Invalid response from Firebase Cloud Function see developer console for details')
                }
            };
            req.onerror = function () {
                commit('setError', 'Network error in Firebase Cloud Function call see developer console for details')
                commit('setLoading', false)

            };
            var url = 'https://us-central1-' + getFirebaseProjectId() + '.cloudfunctions.net/lostpassword';
            req.open('POST', url, true);
            req.setRequestHeader('Content-Type', 'application/json');
            req.send(JSON.stringify({
                username: payload.email
            }));
        },
        test() {
            firebase.auth().currentUser.getIdToken().then(function(token) {
                 //eslint-disable-next-line
                console.log('Sending request with ID token in Authorization header.');
                var req = new XMLHttpRequest();
                req.onload = function() {
                  //eslint-disable-next-line
                  console.log('response',req.responseText);
                }.bind(this);
                req.onerror = function() {
                  //eslint-disable-next-line
                  console.log('error');
                }.bind(this);
                var url = 'https://us-central1-' + getFirebaseProjectId() + '.cloudfunctions.net/auth_test';
                req.open('POST', url, true);
                req.setRequestHeader('Authorization', 'Bearer ' + token);
                req.setRequestHeader('Content-Type', 'application/json');
                req.send();
              }.bind(this));
        },
        userSignIn({ commit }, payload) {
            // Initiates the sign-in flow.
            commit('setLoading', true)
            commit('setError', null)
            var req = new XMLHttpRequest();
            req.onload = function () {
                if (req.status === 400 || req.status === 401) {
                    commit('setError', 'Invalid username or password')
                    commit('setLoading', false)
                    return;
                }
                if (req.status !== 200) {
                    commit('setError', 'Invalid response from Firebase Cloud Function ' + req.status)
                    commit('setLoading', false)
                    return;
                }
                var data = JSON.parse(req.responseText);
                if (data.token) {
                    firebase.auth().signInWithCustomToken(data.token).then((firebaseUser) => {
                        commit('setUser', { email: firebaseUser.user.email })
                        commit('setLoading', false)
                        commit('setError', null)
                        router.push('/home')
                    })
                        .catch(error => {
                            commit('setError', error.message)
                            commit('setLoading', false)
                        })
                } else {
                    // console.log('ERROR RESPONSE: ' + req.responseText);
                    commit('setLoading', false)
                    commit('setError', 'Invalid response from Firebase Cloud Function see developer console for details')
                }
            };
            req.onerror = function () {
                commit('setError', 'Network error in Firebase Cloud Function call see developer console for details')
                commit('setLoading', false)
            };
            var url = 'https://us-central1-' + getFirebaseProjectId() + '.cloudfunctions.net/auth';
            req.open('POST', url, true);
            req.setRequestHeader('Content-Type', 'application/json');
            req.send(JSON.stringify({
                username: payload.email,
                password: payload.password
            }));
        },
        autoSignIn({ commit }, payload) {
            commit('setUser', { email: payload.email })
        },
        userSignOut({ commit }) {
            firebase.auth().signOut()
            commit('setUser', null)
            router.push('/')
        },
        setFirestoreRef: firebaseAction(({ commit, bindFirebaseRef }, { name, ref }) => {
            commit('setLoading', true)
            bindFirebaseRef(name, ref)
                .then(() => commit('setLoading', false))
        }),
        addDocument: firebaseAction(({ commit, bindFirebaseRef }, documentRef) => {
            let docKey = `${documentRef.parent.id}/${documentRef.id}`
            // commit('setDocumentKey', docKey);
            commit('setDocLoading', true)
            commit('setDocumentKey', { key: docKey, value: null });
            commit('setDocLoaded', { key: docKey, value: false })
            bindFirebaseRef(`documents.${docKey}`, documentRef)
                .then(() => {
                    commit('setDocLoaded', { key: docKey, value: true })
                    commit('setDocLoading', false)

                }
                )
        }),
        setFirestoreBindings: firebaseAction(({ commit, bindFirebaseRef }, bindings) => {
            commit('setLoading', true)
            const promises = []
            bindings.forEach(({ name, ref }) => {
                promises.push(bindFirebaseRef(name, ref))
            })
            Promise.all(promises)
                .then(() => commit('setLoading', false))
                .catch(() => {
                    commit('setLoading', false)
                    commit('setError', 'Error binding firestore ref')
                })
        }),
        unbindFirestoreRef: firebaseAction(({ commit, unbindFirebaseRef }, name) => {
            commit('setLoading', true)
            unbindFirebaseRef(name)
                .then(() => commit('setLoading', false))
        })
    },
    getters: {
        isAuthenticated(state) {
            return state.user !== null && state.user !== undefined
        },
        getData(state) {
            return key => {
                return state[key]
            }
        },
        broadcasts: state => state.broadcasts,
        loading: state => state.loading,
        aggregations: state => state.aggregations,
        //senders: state => state.senders,
        entities: state => state.entities,
        //entity_doc: state => state.entity,
        error: state => state.error
    }
})